import React from 'react'
import './About.css'
import AboutImage from '../../assets/sasuke.jpg'
import { HiDownload } from 'react-icons/hi'
import data from './data'
import Card from '../../components/Card'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import Resume from '../../Sai_Pranav_Resume_.pdf'
import Tilt from 'react-parallax-tilt'




const About = () => {

   // Use `useInView` to detect when the component is visible on the screen
   const { ref, inView } = useInView({
    threshold: 0.4, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };
  const topVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  const imageVariants = {
    hidden: { opacity:0  },
    visible: { opacity: 1 , transition: { duration: 1, ease: 'easeInOut' } },
  }

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView, animation]);


  




  return (
    <section id='About'>
      <motion.h2
        variants={topVariants}
        initial="hidden"
        animate={animation}
          
        className='about__name'


        >About Me</motion.h2>
      <motion.div 
      
      className="container about__container" ref={ref}>
        <div className="about__left">
          <motion.div 
          variants={imageVariants} 
          initial="hidden"
          animate={animation}
          className="about__portrait">
            <Tilt className='parallax-effect-glare-scale' perspective={700}
                        glareEnable={true}
                        glareMaxOpacity={0.2}
                        glareBorderRadius ={"1rem"}
                        glarePosition='all'
                        transitionSpeed={1000}
                        scale={1} >

                   <img src={AboutImage} className= 'about__image' alt='about' />
                        </Tilt>
          </motion.div>
        </div>
        <motion.div className="about__right" variants={containerVariants}
          initial="hidden"
          animate={animation}>
        <motion.div 

          
        
        
        className="about__cards">
          {
            data.map(item => (
              <Card 
              key={item.id} className="about__card">
                <span className="about__card-icon">{item.icon}</span>
                 <h5 className='about__title'>{item.title}</h5>
                 <small className='about__desc'>{item.desc}</small>
              </Card>
            ))
          }
        </motion.div>
        <motion.p>
        Hi, I'm Sai Pranav. I'm a Fullstack Developer with a solid understanding of Artificial Intelligence and Blockchain technology.
</motion.p>

<motion.p>
  I can handle any web project you need. Hire me, and I'll bring your concepts to life with my best effort.
</motion.p>

        <motion.div
         variants={imageVariants} 
         initial="hidden"
         animate={animation}>
        <a 
        href={Resume} download className='btn primary2'>Download CV <HiDownload/>
        </a>
        </motion.div>
      </motion.div>


      <motion.div 
       variants={imageVariants} 
       initial="hidden"
       animate={animation}>
      <a 
      href={Resume} download className='btn primary1'>Download CV <HiDownload/></a>
      </motion.div>
      </motion.div>
      
    </section>

  )
}

export default About
